exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-078753dd]:export{menuText:#bfcbd9;menuActiveText:#409eff;subMenuActiveText:#f4f4f5;menuBg:#304156;menuHover:#263445;subMenuBg:#1f2d3d;subMenuHover:#001528;sideBarWidth:205px}.app-main[data-v-078753dd]{min-height:calc(100vh - 66px);padding-top:56px;min-width:780px;margin:0 auto;position:relative}.app-main-router[data-v-078753dd]{padding-bottom:34px;margin:0 auto}.fixed-header+.app-main[data-v-078753dd]{padding-top:77px}.hasTagsView .app-main[data-v-078753dd]{min-height:calc(100vh - 84px)}.hasTagsView .fixed-header+.app-main[data-v-078753dd]{padding-top:115px}", ""]);

// exports
